import { createStore } from '@aibees/shared/store';
import { TableSearchItemStoreData as StoreData } from './types';

// todo: check how we can remove this store
const useTableSearchItemStore = createStore<StoreData>(
  'table-search-item',
  (set) => ({
    selectedItem: undefined,
    setSelectedItem(id) {
      set({ selectedItem: id });
    },
  })
);

export default useTableSearchItemStore;
